import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { Observable, of, switchMap } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { DistrictService } from '../../services/districtService';
import { getDateFromISOString } from '../helper/utils';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-call-by-date-data',
  templateUrl: './callbydate.component.html',
  standalone: true,
  styleUrl: './callbydate.component.scss',
  imports: [DialogModule, DatepickerComponent, TableModule, ToastModule, ConfirmPopupModule, TagModule, SelectModule, ButtonModule, InputTextModule, DatePickerModule, FormsModule, TableComponent, DropdownComponent, ProgressSpinnerModule, ConfirmPopupModule],
  providers: [MessageService, DistrictService, DatePipe, ConfirmationService]
})
export class CallByDateComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;

  router: any;
  param: any;
  processMessage: string = "";
  lsNorthDataColumns: any[] = [];
  criticalLoadDataCommentColumns: any[] = [];
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;

  totalRecords: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;

  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  districtOptions: SelectItem[] = [];
  scheduledDateTakenOptions: SelectItem[] = [];
  dispatchViewOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  masterDataTypesCollection: any = [];
  selectedDistrict: string = "";
  selectedDateTaken: string = "";
  selectedDispatchView: string = "";
  selectedType: any;
  allDistrictData: any[] = [];
  queryParamData: any = {};
  firstRecordOffset: number = 0;
  selectDate: string = "Date Taken";
  sortField: string = "DateTaken";
  sortOrder: number = 1;
  searchText: any = "";

  filteredData$!: Observable<any[]>;
  ConfirmationService: any;


  constructor(
    private route: ActivatedRoute,
    private districtService: DistrictService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private apiService: ApiService
  ) {

  }
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);
    if (temp) {
      this.selectedDistrict = temp.data.DistrictNm;
      this.selectedDispatchView = temp.data.Dispatch_Status;
      this.selectedDateTaken = temp.data.DateTaken;
      this.selectedType = temp.data.Type;
      this.getSelectedDistrictDetails();
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.getMasterDataDetails();
  }

  showDialog() {
    this.dialogVisible = true;
  }

  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;

    this.lsNorthDataColumns = [
      { "field": "DateTaken", "header": "DATE TAKEN", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action", isClickable: 'true', onclick: this.handleClick.bind(this) }
    ];


    this.commentTable = [
      { "field": "message", "header": "USER COMMENTS", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdUser", "header": "CREATE BY", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdDate", "header": "CREATE DATETIME", "filter": true, "isSorting": true, "width": "5%" },
    ]

  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);

    const data = {
      DistrictNm: this.selectedDistrict,
      DateTaken: this.selectedDateTaken,
      Dispatch_Status: this.selectedDispatchView,
      Type: this.selectedType
    }


    const temp = {
      data,
      from: "/bycalldate"
    }

    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  uniqueData(data: any) {
    const uniqueData = data.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.label === value.label && t.value === value.value
      ))
    );

    const sortedData = uniqueData.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return sortedData;
  }

  sortedDate(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);
      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }

  removeDuplicateValues(data: any) {
    return data.reduce((acc: any, current: any) => {
      if (!acc.some((item: any) => item.label === current.label)) {
        acc.push(current);
      }
      return acc;
    }, []);

  }




  LoadDistrictDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.apiService.groupId().pipe(
      switchMap(groupId =>{
        return this.districtService.getDistricts(groupId);
      })
    ).subscribe({
      next: (data: any) => {
        this.districtsMainCollection = data?.Payload;
        const scheduledDta = this.uniqueData(data?.Payload.map((district: any) => ({
          label: this.datePipe.transform(new Date(district.DateTaken.trim()), "MM-dd-yyyy")?.toString(),
          value: district.DateTaken?.trim()?.toString()
        })));

        const sortedScheduledData = this.sortedData(scheduledDta);
        this.scheduledDateTakenOptions = this.removeDuplicateValues(sortedScheduledData?.reverse());
        this.updateDropdownValues();
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByDateComponent.LoadDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => { }
    })
  }


  handlePageChange(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.pageSize;
    this.getSelectedDistrictDetails();

  }

  updateDropdownValues() {

    if (this.selectedDateTaken !== "" && this.selectedType !== "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => getDateFromISOString(item.DateTaken?.trim()) === getDateFromISOString(this.selectedDateTaken?.trim()));

      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));


    }

    if (this.selectedDateTaken !== "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) =>
        getDateFromISOString(item.DateTaken?.trim()) === getDateFromISOString(this.selectedDateTaken?.trim())
      );

      this.typeOptions = this.uniqueData(tempData.map((district: any) => ({
        label: district.Type.trim(),
        value: district.Type
      })));


    }

  }
  sortedData(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);

      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }


  getMasterDataDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;

    this.apiService.groupId().pipe(
      switchMap(groupId => this.districtService.getDistricts(groupId))
    ).subscribe({
      next: (data: any) => {
        this.masterDataTypesCollection = data?.Payload?.OrderTypeData;
        const updatedData = data?.Payload?.OrderTypeData?.map((item: any) => {
          return {

            label: item.Value.trim(),
            value: item?.Value
          }
        });
        this.typeOptions = this.uniqueData(updatedData);
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByDateComponent.getMasterDataDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }



  getSelectedDistrictDetails(): void {

    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true
    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          DateTaken: this.selectedDateTaken === "" ? null : this.selectedDateTaken,
          Type: this.selectedType === "" ? null : this.selectedType,
          UserId: sessionStorage.getItem('userId'),
          RequestType: "calldate",
          PageNumber: this.pageNumber,
          PageSize: this.pageSize,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText,
          groupId: groupId
        }
        return this.districtService.getDistrictDetails(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const updatedData = data?.Payload?.Data?.map((item: any) => {
          return {
            ...item,
            DateTaken: this.datePipe.transform(new Date(item.DateTaken.trim()), "MM-dd-yyyy")?.toString()
          }
        });
        this.totalRecords = data?.Payload?.TotalRecords;
        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
        // this.filteredData = updatedData;
        this.filteredData$ = of(updatedData);
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByDateComponent.getSelectedDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;

      }
    });
  }

  onCellClicked(event: any[]) {
    this.isLoading = true;
    this.cellValue = event;
    this.selectedRow = event[1];
  }


  onCancelCommentClicked() {
    this.txtComment = "";
    this.dialogVisible = false;
  }

  onSaveCommentClicked() {

    this.isLoading = true;
    const cmt = { bqUniqueId: this.selectedRow.bqUniqueId, message: this.txtComment, createdUser: this.user, createdDate: Date() };
    if (cmt === null || cmt === undefined) {
      this.messageService.add({ severity: 'warning', summary: 'warning', detail: environment.appMessages.noChangesFound, life: environment.appSettings.snakbarLife });
      return;
    }

    this.processMessage = environment.appMessages.savinggMesage;
    this.isLoading = false;
  }

  reload() {
    this.tblConfig.clear();
    this.selectedItems = [];
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
    this.selectedDateTaken = '';
    this.selectedDispatchView = '';
    this.selectedType = '';
    this.updateDropdownValues();
  }


  onDateTakenChange(event: any) {
    this.selectedDateTaken = event;
  }

  onDispatchViewChange(event: any) {
    this.selectedDispatchView = event;
    this.selectedType = '';
    this.updateDropdownValues();
  }
  getSearchDisabledStatus() {


    return this.selectedDateTaken === "" || this.selectedType === ""
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onSearch(): void {
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.getSelectedDistrictDetails();

  }
  onClear(): void {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
        this.selectedType = "";
        this.selectedDateTaken = "",
          this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },

    });

  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.getSelectedDistrictDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedDistrictDetails();
  }
}





